import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {FormikSelectGroup} from '../formik/FormikSelectGroup';
import {FormikTextInputGroup} from '../formik/FormikTextInputGroup';
import {useIntl} from 'react-intl';
import {emailValidation} from '../util/validation';

import countriesDE from '../i18n/countries/de';
import countriesEN from '../i18n/countries/en';

import _ from 'lodash';
import * as yup from 'yup';
import SingleFileUpload from "../formik/SingleFileUpload";
import {Form} from "react-bootstrap";
import React from "react";
import {Field} from "formik";

/**
 * @param schema
 * @param personDataConfig
 * @param key
 * @param nullable
 */
const setByKey = (schema, personDataConfig, key, nullable = false) => {
    if (_.get(personDataConfig, `${key}.active`)) {
            schema[key] = yup.string().nullable();
        if (_.get(personDataConfig, `${key}.required`)) {
            schema[key] = schema[key].required();
        }
        if (nullable) {
            schema[key] = schema[key].nullable();
        }
    }
};

/**
 * @param personDataConfig
 * @returns {{}}
 */
export const createContactSchemaFromPersonDataConfig = personDataConfig => {
    const schema = {};

    setByKey(schema, personDataConfig, 'salutation');
    setByKey(schema, personDataConfig, 'title', true);
    setByKey(schema, personDataConfig, 'phone');
    setByKey(schema, personDataConfig, 'company');
    setByKey(schema, personDataConfig, 'firstName');
    setByKey(schema, personDataConfig, 'lastName');
    setByKey(schema, personDataConfig, 'email');
    setByKey(schema, personDataConfig,'function');

    if (personDataConfig.email && personDataConfig.email.active) {
        schema['email'] = schema['email'].concat(emailValidation());
    }

    if (personDataConfig.country && personDataConfig.country.active) {
        schema['countryISOCode'] = yup.string();
        if (personDataConfig.country.required) {
            schema['countryISOCode'] = schema['countryISOCode'].required();
        }
    }

    if (personDataConfig.address && personDataConfig.address.active) {
        schema['street'] = yup.string();
        schema['houseno'] = yup.string();
        schema['postalCode'] = yup.string();
        schema['city'] = yup.string();

        if (personDataConfig.address.required) {
            schema['street'] = schema['street'].required();
            schema['houseno'] = schema['houseno'].required();
            schema['postalCode'] = schema['postalCode'].required();
            schema['city'] = schema['city'].required();
        }
    }

    return schema;
};

/**
 * @param personDataConfig
 * @returns {{}}
 */
export const createPCOPersonDataSchemaFromPersonDataConfig = personDataConfig => {
    const schema = {};

    setByKey(schema, personDataConfig,'imageCaption');
    setByKey(schema, personDataConfig,'image');
    setByKey(schema, personDataConfig,'photographer');

    return schema;
}

/**
 * @param personDataConfig
 * @param personPath
 * @param placeholderLabel
 * @param disabled
 * @returns {JSX.Element}
 * @constructor
 */
export const PersonDataForm = ({personDataConfig, personPath, placeholderLabel, disabled}) => {

    const intl = useIntl();

    const salutationOptions = intl.locale === 'de' ? [
        {label: 'Herr', value: 'Herr'},
        {label: 'Frau', value: 'Frau'},
    ] : [
        {label: 'Mr.', value: 'Herr'},
        {label: 'Mrs.', value: 'Frau'},
    ];

    const countryListToOptions = countries => _.map(countries, (value, key) => {
        return {label: value, value: key};
    });

    const countryOptions = intl.locale === 'de' ? countryListToOptions(countriesDE.countries) : countryListToOptions(countriesEN.countries);

    const getLabel = (fieldConfig, messageKey) => {
        return intl.formatMessage({id: messageKey}) + (fieldConfig.required ? '*' : '');
    };

    return <>
        <Row>
            {personDataConfig.salutation && personDataConfig.salutation.active &&
            <Col>
                <FormikSelectGroup label={getLabel(personDataConfig.salutation, 'submission.form.label.salutation')}
                                   name={`${personPath}.mainContact.salutation`}
                                   placeholderLabel={placeholderLabel}
                                   disabled={disabled}
                                   options={salutationOptions}/>

            </Col>
            }
            {personDataConfig.title && personDataConfig.title.active &&
            <Col>

                <FormikTextInputGroup label={getLabel(personDataConfig.title, 'submission.form.label.title')}
                                      name={`${personPath}.mainContact.title`}
                                      disabled={disabled}
                                      placeholderLabel={placeholderLabel}/>
            </Col>
            }
            {personDataConfig.firstName && personDataConfig.firstName.active &&
            <Col>

                <FormikTextInputGroup label={getLabel(personDataConfig.firstName, 'submission.form.label.firstName')}
                                      name={`${personPath}.mainContact.firstName`}
                                      disabled={disabled}
                                      placeholderLabel={placeholderLabel}/>
            </Col>
            }
            {personDataConfig.lastName && personDataConfig.lastName.active &&
            <Col>

                <FormikTextInputGroup label={getLabel(personDataConfig.lastName, 'submission.form.label.lastName')}
                                      name={`${personPath}.mainContact.lastName`}
                                      disabled={disabled}
                                      placeholderLabel={placeholderLabel}/>
            </Col>
            }
        </Row>
        <Row>
            {personDataConfig.email && personDataConfig.email.active &&
            <Col>
                <FormikTextInputGroup label={getLabel(personDataConfig.email, 'submission.form.label.email')}
                                      name={`${personPath}.mainContact.email`}
                                      disabled={disabled}
                                      placeholderLabel={placeholderLabel}/>
            </Col>
            }
            {personDataConfig.phone && personDataConfig.phone.active &&
            <Col>
                <FormikTextInputGroup label={getLabel(personDataConfig.phone, 'submission.form.label.phone')}
                                      name={`${personPath}.mainContact.phone`}
                                      disabled={disabled}
                                      placeholderLabel={placeholderLabel}/>
            </Col>
            }
        </Row>
        <Row>
            {personDataConfig.company && personDataConfig.company.active &&
            <Col>
                <FormikTextInputGroup label={getLabel(personDataConfig.company, 'submission.form.label.company')}
                                      name={`${personPath}.mainContact.company`}
                                      disabled={disabled}
                                      placeholderLabel={placeholderLabel}/>
            </Col>
            }
        </Row>

        <Row>
            {personDataConfig.country && personDataConfig.country.active &&
            <Col>
                <FormikSelectGroup label={getLabel(personDataConfig.country, 'submission.form.label.country')}
                                   name={`${personPath}.mainContact.countryISOCode`}
                                   placeholderLabel={placeholderLabel}
                                   disabled={disabled}
                                   options={countryOptions}/>
            </Col>
            }

            {personDataConfig.function && personDataConfig.function.active &&
            <Col>
                <FormikTextInputGroup label={getLabel(personDataConfig.function, 'submission.form.label.function')}
                                      name={`${personPath}.mainContact.function`}
                                      disabled={disabled}
                                      placeholderLabel={placeholderLabel}/>
            </Col>
            }
        </Row>

        <Row>
            {personDataConfig.image && personDataConfig.image.active &&
            <Col sm={6}>
                <Field name={`${personPath}.pcoPersonData.image`}>
                    {({field, form}) => {
                        return <Form.Group>
                            <SingleFileUpload
                                value={field.value}
                                onChange={(value) => form.setFieldValue(field.name, value)}
                                accepts="image/bmp, image/png, image/jpeg, image/jpg, image/gif"
                                label="Foto / Logo"
                            />
                            <Form.Control.Feedback type="invalid">
                            </Form.Control.Feedback>
                        </Form.Group>
                    }}

                </Field>
            </Col>
            }
            <Col sm={6}>
                <Row>
                    {personDataConfig.photographer && personDataConfig.photographer.active &&
                    <Col>
                        <FormikTextInputGroup
                            label={getLabel(personDataConfig.photographer, 'submission.form.label.photographer')}
                            name={`${personPath}.pcoPersonData.photographer`}
                            disabled={disabled}
                            placeholderLabel={placeholderLabel}/>
                    </Col>
                    }

                </Row>
                <Row>
                    {personDataConfig.imageCaption && personDataConfig.imageCaption.active &&
                    <Col>
                        <FormikTextInputGroup
                            label={getLabel(personDataConfig.imageCaption, 'submission.form.label.imageCaption')}
                            name={`${personPath}.pcoPersonData.imageCaption`}
                            disabled={disabled}
                            placeholderLabel={placeholderLabel}/>
                    </Col>
                    }
                </Row>
            </Col>
        </Row>

        {personDataConfig.address && personDataConfig.address.active &&
        <>
            <Row>
                <Col sm={9}>
                    <FormikTextInputGroup label={getLabel(personDataConfig.address, 'submission.form.label.street')}
                                          name={`${personPath}.mainContact.street`}
                                          disabled={disabled}
                                          placeholderLabel={placeholderLabel}/>
                </Col>
                <Col sm={3}>
                    <FormikTextInputGroup label={getLabel(personDataConfig.address, 'submission.form.label.houseno')}
                                          name={`${personPath}.mainContact.houseno`}
                                          disabled={disabled}
                                          placeholderLabel={placeholderLabel}/>
                </Col>
            </Row>
            <Row>
                <Col sm={3}>
                    <FormikTextInputGroup label={getLabel(personDataConfig.address, 'submission.form.label.postalCode')}
                                          name={`${personPath}.mainContact.postalCode`}
                                          disabled={disabled}
                                          placeholderLabel={placeholderLabel}/>
                </Col>
                <Col sm={9}>
                    <FormikTextInputGroup label={getLabel(personDataConfig.address, 'submission.form.label.city')}
                                          name={`${personPath}.mainContact.city`}
                                          disabled={disabled}
                                          placeholderLabel={placeholderLabel}/>
                </Col>
            </Row>
        </>
        }
    </>
};

export default PersonDataForm;
